export class AddResourceDto {

    title?: string;

    published: boolean = false;

    free: boolean = false;

    description?: string;
}